import { create } from "zustand";
import { CreateAccessionFormSchema } from "./schema";

interface CreateAccessionState {
  initialData: Partial<CreateAccessionFormSchema> | null;
  createAccessionDialogOpen: boolean;
  setCreateAccessionDialogOpen: (
    open: boolean,
    initialData?: Partial<CreateAccessionFormSchema> | null,
  ) => void;
}

export const useCreateAccessionStore = create<CreateAccessionState>((set) => ({
  initialData: null,
  createAccessionDialogOpen: false,
  setCreateAccessionDialogOpen: (open, initialData) => {
    if (!open) {
      set({ createAccessionDialogOpen: open, initialData: null });
    } else {
      set({ createAccessionDialogOpen: open, initialData });
    }
  },
}));
